import { IComponentProps, NotificationBox, SnackBar } from "@starrez/starryui";
import React from "react";
import { MessageContainerDiv } from "./Message.styles";

export const Message = (props: IComponentProps) => {
    const notificationProps = {
        ...props,
        EnableIcon: true,
    };

    return (
        <MessageContainerDiv>
            <SnackBar>
                <NotificationBox {...notificationProps} />
            </SnackBar>
        </MessageContainerDiv>
    );
};
